export const environment = {
  production: false,
  version: '1.3.10',
  api: {
    url: 'https://api-staging.bitoasisdev.com', /* 'https://api-k8s.bitoasisdev.net', */
    websocket: 'wss://wss-staging.bitoasisdev.com',
    clientId: 'bitoasis-webapp',
    clientSecret: 'Ae9tl11ru8', /* '7kNQtZsoZkaf8GnQZfMMhnJZ4DpzDm9y' */
    type: 'web'
  },
  googleAnalytics: {
    id: 'GTM-PP87BFN'
  },
  segmentAnalytics: {
    key: 'xlqOJDSyYsCO3Yu70k3g1Pcj8HOt559d',
  },
  currencies: {
    globalCurrency: 'USD',
    defaultCurrency: 'AED'
  },
  hcaptcha: {
    enabled: false,
    siteKey: 'b7a91006-f3d5-4cc1-947e-7b69136d1847',
    passiveSiteKey: '635a8d80-3bd8-4d7a-a67b-61268e457b59',
  },
  blog: {
    api: 'https://blog.bitoasis.net/wp-json/wp/v2',
    homePage: {
      postsNumber: 5,
      category: {
        en: 315,
        ar: 323
      }
    },
    announcements: {
      category: {
        en: 291,
        ar: 293
      },
      duration: 12000,
      utm: 'utm_source=website&utm_medium=website-announcements-area&utm_campaign=website-announcements&utm_content=textlink'
    },
    howProWorks: {
      slug: 'how-pro-works'
    }
  },
  links: {
    apiDocs: 'https://api.bitoasis.net/doc/',
    blog: 'https://blog.bitoasis.net/',
    careers: 'https://apply.workable.com/bitoasis/',
    security: {
      en: 'https://bitoasis.net/static/en/security',
      ar: 'https://bitoasis.net/static/ar/security'
    },
    support: {
      en: 'https://support.bitoasis.net/en/support/home',
      ar: 'https://support.bitoasis.net/ar/support/home'
    }
  },
};
